var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcTelegram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "44px",
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_telegram") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BDF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003FD1",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22,1 C33.5979801,1 43,10.4020199 43,22 C43,33.5979801 33.5979801,43 22,43 C10.4020199,43 1,33.5979801 1,22 C1,10.4020199 10.4020199,1 22,1 Z M31.7981771,11.5486058 C31.3399248,11.5476451 30.7240482,11.7559558 30.6328308,11.7888305 L30.6213517,11.7931717 L8.34317208,20.6434087 C8.34317208,20.6434087 7.3680575,20.9548621 7.3680575,21.6080729 C7.3680575,22.3396701 8.19381857,22.6269756 8.30392004,22.6620315 L8.3159975,22.6657525 L13.6409792,24.0819167 L13.647,24.085 L27.4305417,15.836815 C27.6349261,15.6816691 27.9152816,15.6974637 28.0991107,15.8643759 L28.1631792,15.9340129 C28.3377183,16.1639425 28.2948667,16.49107 28.0649371,16.6656092 L28.0649371,16.6656092 L17.7891325,26.1721925 L16.783,32.391 L16.7816225,32.4054038 C16.8610521,32.4409375 16.9383933,32.452435 17.0105079,32.4503438 C17.1887779,32.4458638 17.3286565,32.3569209 17.3649836,32.3316001 L17.3742162,32.3249271 L20.954,28.798 L26.2704375,33.2101587 C26.2704375,33.2101587 26.5269716,33.4468258 27.0259057,33.4898561 L27.1828437,33.4965258 C28.2528328,33.4965258 28.4623678,32.6817506 28.4823471,32.59122 L28.4840417,32.5830754 L32.39913,12.59375 C32.39913,12.59375 32.4513879,12.3324633 32.4513879,12.0711796 C32.4513879,11.6792525 32.1033567,11.5486058 31.7981771,11.5486058 Z",
    id: "ic_telegram",
    fill: "url(#linearGradient-1)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTelegram);
export default __webpack_public_path__ + "static/media/ic_telegram.c74bd3325621afd33388a30ae6675832.svg";
export { ForwardRef as ReactComponent };